import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
//* Fecha formato
import Divider from "@mui/material/Divider";
import { format } from "date-fns";
import bdService from "../../../services/maestros.service";
import bdBodega from "../../../services/bodega.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack"; //Para alertas notificaciones
//****** iconos */
import LocalShippingTwoToneIcon from "@mui/icons-material/LocalShippingTwoTone";
import EventNoteTwoToneIcon from "@mui/icons-material/EventNoteTwoTone";
//import styled from "@emotion/styled";
import ListAltIcon from "@mui/icons-material/ListAlt";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useEffect, useRef, useState } from "react";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
// import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import BallotIcon from "@mui/icons-material/Ballot";
import CropFreeIcon from "@mui/icons-material/CropFree";
import TextFieldCustom from "../../../helpers/CustomTextFields";
import NumFormato from "../../../helpers/numerico";

const Despachos = () => {
  const { enqueueSnackbar } = useSnackbar();
  //********** Sucursal ******************************/
  const [sucursales, setSucursales] = useState([]);
  const [bSeleccionada, setbSeleccionada] = useState(false);
  const [NomBodega, setNomBodega] = useState(null);
  const [SucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [BodegaSeleccionada, setBodegaSeleccionada] = useState("");
  const [bBodegaConPreparacion, setbBodegaConPreparacion] = useState(false);
  //**************************************** */
  const [datalistMonitor, setdatalistMonitor] = useState([]);
  const [datadetalle, setdatadetalle] = useState([]);
  const [bSeleccionDesRes, setbSeleccionDesRes] = useState(false);
  const [bMostarListado, setbMostarListado] = useState(false);
  const [isDesRes, setDesRes] = useState("");
  const [bScanResDes, setbScanResDes] = useState(false);

  const [bConDatos, setbConDatos] = useState(false);
  //**************************************** */
  /* Datos Seleccionados */
  //**************************************** */
  const [iNumero, setNumero] = useState(0);
  const [sReferencia, setReferencia] = useState("");
  //**************************************** */
  const [bMostrarDato, setbMostrarDato] = useState(false);
  const [iMostrarCantidad, setiMostrarCantidad] = useState(0);
  // eslint-disable-next-line
  const [iMostrarStk, setiMostrarStk] = useState(0);
  const [iMostrarPreparado, setiMostrarPreparado] = useState(0);
  const [iMostrarPendiente, setiMostrarPendiente] = useState(0);
  const [iMostrarEntregado, setiMostrarEntregado] = useState(0);
  const [iMostrarNoEntregado, setiMostrarNoEntregado] = useState(0);
  const [sMostrarDescripcion, setsMostrarDescripcion] = useState("");
  const [sMostrarCodigo, setsMostrarCodigo] = useState("");
  const [iMostrarItem, setiMostrarItem] = useState(0);
  const [iDatoAnterior, setDatoAnterior] = useState(0);
  const [bListadoFaltante, setbListadoFaltante] = useState(false);
  const [iCantidadPreparada, setiCantidadPreparada] = useState(0);
  //**************************************** */
  // Redux
  //**************************************** */
  const { usuario } = useSelector((state) => state.user);
  //*************************************** */
  const ScanBarraRef = useRef(null);
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  const NDocRef = useRef(null);

  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [listaFiltrada, setListaFiltrada] = useState(datalistMonitor);

  const Limpiar = () => {
    //********** Sucursal ******************************/
    setbSeleccionada(false);
    setNomBodega("");
    setSucursalSeleccionada(null);
    setBodegaSeleccionada("");
    setdatalistMonitor([]);
    setdatadetalle([]);
    setbSeleccionDesRes(false);
    setbMostarListado(false);
    setDesRes("");
    setbScanResDes(false);
    setNumero(0);
    setReferencia("");
    setbMostrarDato(false);
    setiMostrarCantidad(0);
    setiMostrarStk(0);
    setiMostrarItem(0);
    setiMostrarPendiente(0);
    setsMostrarDescripcion("");
    setiMostrarPreparado(0);
    setsMostrarCodigo("");
    setiMostrarEntregado(0);
    setiMostrarNoEntregado(0);
    setbListadoFaltante(false);
  };
  const CalcularPendiente = (
    var_Cantidad,
    var_Entregado,
    var_NoEntregado,
    var_Pendiente,
    var_ValorAnterior,
    var_Ent_NoEnt,
  ) => {
    /*************************************************** */
    var_Pendiente = var_Cantidad - (var_Entregado + var_NoEntregado);
    /*************************************************** */
    //setiCantidadPreparada(resultado.Preparado);
    /*************************************************** */
    // console.log("Entro 1");
    // console.log("Entregado", var_Entregado);
    // console.log("NoEntregado", var_NoEntregado);
    // console.log("Pendiente", var_Pendiente);
    // console.log("Valor Anterior", var_ValorAnterior);
    // console.log("Preparado:", iCantidadPreparada);
    // console.log("Val Cantidad", var_Cantidad);
    /*************************************************** */
    /* Valida si tiene Preparación ya se con o sin Sucursal Obligatoria */
    if (bBodegaConPreparacion) {
      // Si es bodega con preparación no puede superar la preparacion a lo entregado
      // Estoy digitando Entrado
      //if (var_Ent_NoEnt === "E") {
      if (
        !(iCantidadPreparada >= var_Entregado) ||
        !(var_Cantidad - iCantidadPreparada >= var_NoEntregado)
      ) {
        enqueueSnackbar(`Este item, Supera la PREPARACIÓN!!...`, {
          variant: "warning",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        if (var_Ent_NoEnt === "E") {
          var_Pendiente = var_Cantidad - (var_ValorAnterior + var_NoEntregado);
          setiMostrarEntregado(
            NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2),
          );
          setiMostrarPendiente(
            NumFormato.NumeroFormateado(var_Pendiente, false, true, 2),
          );
        } else {
          var_Pendiente = var_Cantidad - (var_ValorAnterior + var_NoEntregado);
          setiMostrarNoEntregado(
            NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2),
          );
          setiMostrarPendiente(
            NumFormato.NumeroFormateado(var_Pendiente, false, true, 2),
          );
        }
        return;
      }
    }

    if (var_Cantidad < var_Entregado + var_NoEntregado) {
      enqueueSnackbar(`El Item no puede ser superior a la cantidad..`, {
        variant: "warning",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      if (var_Ent_NoEnt === "N") {
        /* Modifica el no entregado */
        var_Pendiente = var_Cantidad - (var_ValorAnterior + var_Entregado);
        setiMostrarNoEntregado(
          NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2),
        );
        setiMostrarPendiente(
          NumFormato.NumeroFormateado(var_Pendiente, false, true, 2),
        );
      } else {
        /* Modifica el entregado */
        var_Pendiente = var_Cantidad - (var_ValorAnterior + var_NoEntregado);
        setiMostrarEntregado(
          NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2),
        );
        setiMostrarPendiente(
          NumFormato.NumeroFormateado(var_Pendiente, false, true, 2),
        );
      }
      return;
    }
  };

  // const CalcularPendiente = (
  //   var_Cantidad,
  //   var_Entregado,
  //   var_NoEntregado,
  //   var_Pendiente,
  //   var_ValorAnterior,
  //   var_Ent_NoEnt
  // ) => {
  //   /*************************************************** */
  //   var_Pendiente = var_Cantidad - (var_Entregado + var_NoEntregado);
  //   /*************************************************** */
  //   //setiCantidadPreparada(resultado.Preparado);
  //   /*************************************************** */
  //   // console.log("Entro 1");
  //   // console.log("Entregado", var_Entregado);
  //   // console.log("NoEntregado", var_NoEntregado);
  //   // console.log("Pendiente", var_Pendiente);
  //   // console.log("Valor Anterior", var_ValorAnterior);
  //   // console.log("Preparado:", iCantidadPreparada);
  //   // console.log("Val Cantidad", var_Cantidad);
  //   /*************************************************** */
  //   /* Valida si tiene Preparación ya se con o sin Sucursal Obligatoria */
  //   if (var_Cantidad < var_Entregado + var_NoEntregado) {
  //     enqueueSnackbar(`El Item no puede ser superior a la cantidad..`, {
  //       variant: "warning",
  //       anchorOrigin: {
  //         vertical: "top",
  //         horizontal: "right",
  //       },
  //     });
  //     if (var_Ent_NoEnt === "N") {
  //       /* Modifica el no entregado */
  //       var_Pendiente = var_Cantidad - (var_ValorAnterior + var_Entregado);
  //       setiMostrarNoEntregado(
  //         NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2)
  //       );
  //       setiMostrarPendiente(
  //         NumFormato.NumeroFormateado(var_Pendiente, false, true, 2)
  //       );
  //     } else {
  //       /* Modifica el entregado */
  //       var_Pendiente = var_Cantidad - (var_ValorAnterior + var_NoEntregado);
  //       setiMostrarEntregado(
  //         NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2)
  //       );
  //       setiMostrarPendiente(
  //         NumFormato.NumeroFormateado(var_Pendiente, false, true, 2)
  //       );
  //     }
  //     return;
  //   }

  //   if (iCantidadPreparada > 0) {
  //     // Valor No Entragdo

  //     if (var_Ent_NoEnt === "N") {
  //       if (iCantidadPreparada < var_Entregado + var_NoEntregado) {
  //         enqueueSnackbar(
  //           `Este item, tiene PREPARACIÓN no puede ser No entregado...`,
  //           {
  //             variant: "warning",
  //             anchorOrigin: {
  //               vertical: "top",
  //               horizontal: "right",
  //             },
  //           }
  //         );
  //         /* Modifica el no entregado */
  //         var_Pendiente = var_Cantidad - (var_ValorAnterior + var_Entregado);
  //         setiMostrarNoEntregado(
  //           NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2)
  //         );
  //         setiMostrarPendiente(
  //           NumFormato.NumeroFormateado(var_Pendiente, false, true, 2)
  //         );
  //       }
  //     }
  //   }
  //   if (bBodegaConPreparacion) {
  //     // Si es bodega con preparación no puede superar la preparacion a lo entregado
  //     // Estoy digitando Entrado
  //     if (var_Ent_NoEnt === "E") {
  //       console.log(var_Entregado + var_NoEntregado);
  //       if (iCantidadPreparada < var_Entregado + var_NoEntregado) {
  //         enqueueSnackbar(`Este item, Supera la PREPARACIÓN!!...`, {
  //           variant: "warning",
  //           anchorOrigin: {
  //             vertical: "top",
  //             horizontal: "right",
  //           },
  //         });
  //         var_Pendiente = var_Cantidad - (var_ValorAnterior + var_NoEntregado);
  //         setiMostrarEntregado(
  //           NumFormato.NumeroFormateado(var_ValorAnterior, false, true, 2)
  //         );
  //         setiMostrarPendiente(
  //           NumFormato.NumeroFormateado(var_Pendiente, false, true, 2)
  //         );
  //       }
  //     }
  //   }
  //   //Sin Preparacion
  //   setiMostrarPendiente(
  //     NumFormato.NumeroFormateado(var_Pendiente, false, true, 2)
  //   );
  // };

  const LimpiarEntrega = () => {
    setiMostrarCantidad(0);
    setiMostrarStk(0);
    setiMostrarItem(0);
    setiMostrarPendiente(0);
    setsMostrarDescripcion("");
    setsMostrarCodigo("");
    setiMostrarEntregado(0);
    setiMostrarNoEntregado(0);
    setiMostrarPreparado(0);
    setbListadoFaltante(false);
  };

  const CargarBodegas = async () => {
    try {
      const iSucursal =
        parseInt(usuario.TipoUsuario) <= 1 ? -1 : usuario.Sucursal;
      const datos = await bdService.Bodegas(iSucursal, "A");
      setbBodegaConPreparacion(false);
      if (datos.status === 200) {
        // Llenado
        setSucursales(datos.data.Sucursales);
        if (parseInt(usuario.TipoUsuario) <= 1) {
          //******** Seleccionar una sucursal */
          setbSeleccionada(false);
          setbBodegaConPreparacion(false);
        } else {
          if (datos.data.Sucursales.length === 1) {
            //******** Asignando datos de la bodega automaticamente */
            setNomBodega(datos.data.Sucursales[0].Nombre);
            setSucursalSeleccionada(datos.data.Sucursales[0].Sucursal);
            setBodegaSeleccionada(datos.data.Sucursales[0].Bodega);
            setbSeleccionada(true);
            setbSeleccionDesRes(true);
            setbBodegaConPreparacion(datos.data.Sucursales[0].Despacho === "P");
          } else {
            //******** Seleccionar una sucursal */
            setbSeleccionada(false);
          }
        }
      } else if (datos.status === 400) {
        // Esta mal
      }
    } catch (error) {
      // Manejo del error si ocurre
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    Limpiar();
    CargarBodegas();
  }, []);

  //********************* Combo sucursal */
  const handleChangeComboBox = async (event) => {
    const nombreSeleccionado = event.target.value;
    const SucBodSelect = sucursales.find(
      (sucursal) => sucursal.Nombre === nombreSeleccionado,
    );
    setSucursalSeleccionada(SucBodSelect.Sucursal);
    setBodegaSeleccionada(SucBodSelect.Bodega);
    setNomBodega(nombreSeleccionado);
    setbSeleccionada(true); //cambia a seleccionada a true para continuar
    setbSeleccionDesRes(true); // Para que aparezca los botones de Despacho y Reserva
    setbBodegaConPreparacion(SucBodSelect.Despacho === "P"); // Para Bloquear si es con Preparación
  };

  //*********************************************************** */
  //**************** Consultando al CodigoBarra */
  //*********************************************************** */
  const handleScanBarraRefLostFocus = (event) => {};

  const handleKeyDownCodBarra = (event) => {
    if (event.key === "Enter") {
      var CodigoBarra_value = event.target.value;
      var _CodigoBarra;

      if (CodigoBarra_value === null) {
        _CodigoBarra = "*";
      } else {
        _CodigoBarra = CodigoBarra_value.padStart(15, "*");
      }

      const resultado = datadetalle.find(
        (item) => item.CodigoBarra === _CodigoBarra && item.Pendiente > 0,
      );

      if (resultado) {
        /*************************************************** */
        setiCantidadPreparada(resultado.Preparado);
        /*************************************************** */
        if (resultado.Pendiente === 0) {
          enqueueSnackbar(`Este item se encuentra listo para entrega...`, {
            variant: "info",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          event.target.value = "";
          setTimeout(() => {
            ScanBarraRef.current.focus();
          }, 500);
          return;
        }
        /************************************************************************************** */
        /* Con preparación si bodega esta seleccionada en P y elm valor de la preparacion es = 0 
        /************************************************************************************** */
        if (bBodegaConPreparacion && resultado.Preparado === 0) {
          enqueueSnackbar(
            `¡¡ REQUIERE PREPARACIÓN !!! Este item no se encuentra preparado..`,
            {
              variant: "warning",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            },
          );
          event.target.value = "";
          setTimeout(() => {
            ScanBarraRef.current.focus();
          }, 500);
          return;
        }
        /************************************************************************************** */
        if (sMostrarCodigo !== resultado.Codigo) {
          if (
            NumFormato.ConvertirNumero(iMostrarEntregado) +
              NumFormato.ConvertirNumero(iMostrarNoEntregado) <=
              NumFormato.ConvertirNumero(iMostrarCantidad) &&
            sMostrarCodigo.toString().length > 0
          ) {
            enqueueSnackbar(
              `Esta seleccionando otro código antes de continuar grabe el item...`,
              {
                variant: "Customvariante",
                style: { backgroundColor: "#D2B4DE", color: "#FFFFFF" },
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              },
            );
            event.target.value = "";
            setTimeout(() => {
              ScanBarraRef.current.focus();
            }, 500);
            return;
          }
          if (
            resultado.Pendiente > 0 &&
            ((bBodegaConPreparacion &&
              resultado.Preparado >= resultado.Entregado + 1) ||
              bBodegaConPreparacion === false)
          ) {
            /*************************************************** */
            setsMostrarDescripcion(resultado.Nombre);
            setsMostrarCodigo(resultado.Codigo);
            setiMostrarItem(resultado.Item);
            /*************************************************** */
            setiMostrarCantidad(
              NumFormato.NumeroFormateado(resultado.Cantidad, false, true, 2),
            );
            setiMostrarPreparado(
              NumFormato.NumeroFormateado(resultado.Preparado, false, true, 2),
            );
            /*************************************************** */
            setiMostrarEntregado(
              NumFormato.NumeroFormateado(
                resultado.Entregado + 1,
                false,
                true,
                2,
              ),
            );
            /*************************************************** */
            setiMostrarNoEntregado(
              NumFormato.NumeroFormateado(
                resultado.NoEntregado,
                false,
                true,
                2,
              ),
            );
            /*************************************************** */
            setiMostrarPendiente(
              NumFormato.NumeroFormateado(
                resultado.Pendiente - 1,
                false,
                true,
                2,
              ),
            );
            /*************************************************** */
            setiMostrarStk(
              NumFormato.NumeroFormateado(resultado.Stock, false, true, 2),
            );
            /*************************************************** */
            /*************************************************** */
            setbMostrarDato(true);
            /*************************************************** */
          } else {
            if (resultado.Pendiente === 0) {
              enqueueSnackbar(`Este item se encuentra listo para entrega...`, {
                variant: "info",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
              event.target.value = "";
              setTimeout(() => {
                ScanBarraRef.current.focus();
              }, 500);
              return;
            } else {
              if (
                bBodegaConPreparacion &&
                resultado.Preparado < resultado.Entregado + 1
              ) {
                enqueueSnackbar(`Este item, le falta ¡¡PREPARACION!!!...`, {
                  variant: "warning",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                });
                event.target.value = "";
                setTimeout(() => {
                  ScanBarraRef.current.focus();
                }, 500);
                return;
              }
            }
          }
        } else {
          var var_Entregado = NumFormato.ConvertirNumero(iMostrarEntregado);
          var var_NoEntregado = NumFormato.ConvertirNumero(iMostrarNoEntregado);
          var var_Cantidad = NumFormato.ConvertirNumero(iMostrarCantidad);
          var var_Pendiente = NumFormato.ConvertirNumero(iMostrarPendiente);

          var var_EntregadoNuevo = var_Entregado + 1;

          if (
            bBodegaConPreparacion &&
            resultado.Preparado < var_EntregadoNuevo
          ) {
            enqueueSnackbar(`Este item, le falta ¡¡PREPARACION!!!...`, {
              variant: "warning",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            event.target.value = "";
            setTimeout(() => {
              ScanBarraRef.current.focus();
            }, 500);
            return;
          }

          if (var_EntregadoNuevo + var_NoEntregado <= var_Cantidad) {
            /*************************************************** */
            //Estan los valores formateados se cambia a numerico y luego se formatea
            /*************************************************** */

            /*************************************************** */
            setiMostrarPendiente(
              NumFormato.NumeroFormateado(var_Pendiente - 1, false, true, 2),
            );
            setiMostrarEntregado(
              NumFormato.NumeroFormateado(var_EntregadoNuevo, false, true, 2),
            );
            /*************************************************** */

            /*************************************************** */
            setbMostrarDato(true);
          } else {
            enqueueSnackbar(
              `Este item esta completo debe grabar antes de continuar...`,
              {
                variant: "warning",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              },
            );
            event.target.value = "";
            setTimeout(() => {
              ScanBarraRef.current.focus();
            }, 500);
            return;
          }
        }
      } else {
        enqueueSnackbar(
          `No se encuentra este código de barra dentro del documento`,
          {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          },
        );
      }
      event.target.value = "";
      setTimeout(() => {
        ScanBarraRef.current.focus();
      }, 500);
    }
  };

  //*********************************************************** */
  // Botones
  //*********************************************************** */
  const RecargarDatalistMonitor = async (cModo) => {
    try {
      const response = await bdBodega.dsMonitor(
        cModo,
        SucursalSeleccionada,
        BodegaSeleccionada,
        "*",
      );
      if (response.status === 200) {
        setdatalistMonitor(response.data.monitor);
        setListaFiltrada(response.data.monitor);
      } else {
        enqueueSnackbar(`Error en extración de datos ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
    }
  };

  const DatosMonitor = async (cModo) => {
    try {
      const response = await bdBodega.dsMonitor(
        cModo,
        SucursalSeleccionada,
        BodegaSeleccionada,
        "*",
      );
      if (response.status === 200) {
        setdatalistMonitor(response.data.monitor);
        setListaFiltrada(response.data.monitor);
        // console.log(response.data.monitor);
        setbSeleccionDesRes(false);
        setDesRes(cModo);
        setbMostarListado(true);
      } else {
        enqueueSnackbar(`Error en extración de datos ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
    }
  };
  const onClickDespacho = () => {
    DatosMonitor("D");
  };

  const onClickReserva = () => {
    DatosMonitor("R");
  };

  const onRecargarLista = async () => {
    try {
      let response;
      if (isDesRes === "R") {
        response = await bdBodega.dsresbodegadet(
          SucursalSeleccionada,
          BodegaSeleccionada,
          iNumero,
        );
      } else {
        response = await bdBodega.dsdesbodegadet(
          SucursalSeleccionada,
          BodegaSeleccionada,
          iNumero,
        );
      }
      if (response.status === 200) {
        let datos;
        if (isDesRes === "D") {
          datos = response.data.desbodegadet;
        } else {
          datos = response.data.resbodegadet;
        }
        setdatadetalle(datos);
        return datos;
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };
  const onClickLista = async (valor) => {
    try {
      let response;
      if (isDesRes === "R") {
        response = await bdBodega.dsresbodegadet(
          SucursalSeleccionada,
          BodegaSeleccionada,
          valor.Numero,
        );
      } else {
        response = await bdBodega.dsdesbodegadet(
          SucursalSeleccionada,
          BodegaSeleccionada,
          valor.Numero,
        );
      }
      if (response.status === 200) {
        let datos;
        if (isDesRes === "D") {
          datos = response.data.desbodegadet;
        } else {
          datos = response.data.resbodegadet;
        }
        setdatadetalle(datos);
        setbMostarListado(false);
        setbScanResDes(true);
        setNumero(valor.Numero);
        setReferencia(valor.Referencia);
        setTimeout(() => {
          ScanBarraRef.current.focus();
        }, 300);
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };

  const onClickVolver = () => {
    setbMostarListado(false);
    setbSeleccionDesRes(true);
    setbScanResDes(false);
    setbMostrarDato(false);
    LimpiarEntrega();
  };

  const onClickListado = () => {
    RecargarDatalistMonitor(isDesRes);
    setbScanResDes(false);
    setbMostarListado(true);
    setbMostrarDato(false);
    LimpiarEntrega();
  };

  // //******************* Entregado ******************* */
  const handle_GotFocus_Entregado = (value) => {
    setDatoAnterior(value.target.value); // Colocando el valor anterior 1.000,6 a 1000,6
    setiMostrarEntregado(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
  };

  const handle_Change_Entregado = (value) => {
    setiMostrarEntregado(value);
  };

  const handle_KeyDown_Entregado = (event) => {
    if (event.key === "Enter") {
      setTimeout(() => {
        ScanBarraRef.current.focus();
      }, 200);
    }
  };

  const handle_LostFocus_Entregado = (value) => {
    //Lo pasa formateado
    setiMostrarEntregado(value.target.value); //lo pasa a formato.

    setTimeout(() => {
      CalcularPendiente(
        NumFormato.ConvertirNumero(iMostrarCantidad),
        NumFormato.ConvertirNumero(value.target.value),
        NumFormato.ConvertirNumero(iMostrarNoEntregado),
        NumFormato.ConvertirNumero(iMostrarPendiente),
        NumFormato.ConvertirNumero(iDatoAnterior),
        "E",
      );
    }, 200);
  };

  //******************* No Entregado ******************* */
  const handle_GotFocus_NoEntregado = (value) => {
    setiMostrarNoEntregado(value.target.value);
    setDatoAnterior(parseFloat(iMostrarNoEntregado));
  };

  const handle_Change_NoEntregado = (value) => {
    setiMostrarNoEntregado(value);
  };
  const handle_KeyDown_NoEntregado = (event) => {
    if (event.key === "Enter") {
      setTimeout(() => {
        ScanBarraRef.current.focus();
      }, 200);
    }
  };

  const handle_LostFocus_NoEntregado = (value) => {
    setiMostrarNoEntregado(value.target.value); //formateando
    setTimeout(() => {
      CalcularPendiente(
        NumFormato.ConvertirNumero(iMostrarCantidad),
        NumFormato.ConvertirNumero(iMostrarEntregado),
        NumFormato.ConvertirNumero(value.target.value),
        NumFormato.ConvertirNumero(iMostrarPendiente),
        NumFormato.ConvertirNumero(iDatoAnterior),
        "N",
      );
    }, 200);
  };

  //*********************************************************** */
  // Botones avatar
  //*********************************************************** */
  const handleOpenDialogConfirmacion_return = () => {
    LimpiarEntrega();
    setbMostrarDato(false);
    setTimeout(() => {
      ScanBarraRef.current.focus();
    }, 200);
  };

  // const onClickEntregado = async () => {
  //   let total = 0;
  //   if (iCantidadPreparada > 0) {
  //     total = NumFormato.ConvertirNumero(iCantidadPreparada);
  //   } else {
  //     total =
  //       NumFormato.ConvertirNumero(iMostrarCantidad) -
  //       NumFormato.ConvertirNumero(iMostrarNoEntregado);
  //   }
  //   setiMostrarEntregado(NumFormato.NumeroFormateado(total, false, true, 2));
  //   setiMostrarPendiente(0);
  // };

  // const onClickNoEntregado = async () => {
  //   let Total = 0;
  //   if (iCantidadPreparada > 0) {
  //     Total = NumFormato.ConvertirNumero(iMostrarCantidad) - iCantidadPreparada;
  //   } else {
  //     Total =
  //       NumFormato.ConvertirNumero(iMostrarCantidad) -
  //       NumFormato.ConvertirNumero(iMostrarEntregado);
  //   }
  //   setiMostrarNoEntregado(NumFormato.NumeroFormateado(Total, false, true, 2));
  //   setiMostrarPendiente(0);
  // };

  const onclickListadoFaltantes = async () => {
    setbScanResDes(false);
    setbConDatos(bMostrarDato);
    setbMostrarDato(false);
    setbListadoFaltante(true);
  };

  const onClickScann = async () => {
    setbScanResDes(true);
    setbMostrarDato(bConDatos);
    setbListadoFaltante(false);
    setTimeout(() => {
      ScanBarraRef.current.focus();
    }, 200);
  };

  const onClickActualizar = async () => {
    try {
      //isDesRes = R = Reserva y  D = Despacho
      // C = Despacho y D = Preparacion
      let response;
      if (isDesRes === "D") {
        response = await bdBodega.Put_bodega_desbodegadet(
          "C",
          SucursalSeleccionada,
          BodegaSeleccionada,
          iNumero,
          iMostrarItem,
          sMostrarCodigo,
          NumFormato.ConvertirNumero(iMostrarCantidad),
          0,
          NumFormato.ConvertirNumero(iMostrarEntregado),
          NumFormato.ConvertirNumero(iMostrarNoEntregado),
          "",
          0,
          usuario.Id,
        );
      } else {
        response = await bdBodega.Put_bodega_resbodegadet(
          "R",
          SucursalSeleccionada,
          BodegaSeleccionada,
          iNumero,
          iMostrarItem,
          sMostrarCodigo,
          NumFormato.ConvertirNumero(iMostrarCantidad),
          "",
          -1,
          "00000000000000",
          NumFormato.ConvertirNumero(iMostrarEntregado),
          NumFormato.ConvertirNumero(iMostrarNoEntregado),
          "",
          "",
          0,
          0,
          "",
          0,
        );
      }

      if (response.status === 200) {
        enqueueSnackbar(`¡¡¡Registro actualizado!!!`, {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        //*** Reinicia para otro código */
        const dsdetalle = await onRecargarLista();
        LimpiarEntrega();
        setbMostrarDato(false);
        //**************** */
        let hayPendienteMayorCero = false;
        for (const dato of dsdetalle) {
          if (dato.Pendiente > 0) {
            hayPendienteMayorCero = true;
            break; // Si encontramos uno con Pendiente > 0, no necesitamos seguir verificando
          }
        }
        if (!hayPendienteMayorCero) {
          onClickListado();
        } else {
          setTimeout(() => {
            ScanBarraRef.current.focus();
          }, 200);
        }
        //***
      } else {
        enqueueSnackbar(`Error en grabación ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
    }
  };

  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // enfocar input escondido
      }
    }, 200);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const tipoMap = {
    52: "C",
    39: "B",
    110: "D",
    34: "E",
    33: "F",
  };

  const buscarPorNumeroXML = (numeroXML, tipoXML) => {
    // console.log("Lista completa:", datalistMonitor); // ver todos los items
    // console.log("Número que buscamos del XML:", numeroXML);
    const tipoSistema = tipoMap[tipoXML]; // convierte 52 -> "C", 29 -> "B", etc.

    if (!tipoSistema) {
      console.warn(`Tipo XML ${tipoXML} no está mapeado`);
      return null;
    }

    // Buscar por NumDocRef
    let itemEncontrado = datalistMonitor.find(
      (item) =>
        item.NumDocRef?.toString() === numeroXML.toString() &&
        item.DocRef === tipoSistema &&
        item.ClaseRef === "E" &&
        item.Estado !== "C",
    );

    // console.log("Item encontrado por NumDocRef:", itemEncontrado);
    // console.log(datalistMonitor);
    // Buscar por NumGuia si es enviado con guia transporte u otra
    if (
      !itemEncontrado &&
      (tipoSistema === "C" || tipoXML === "52" || tipoXML === "Guia")
    ) {
      itemEncontrado = datalistMonitor.find(
        (item) =>
          item.NumGuia?.toString() === numeroXML.toString() &&
          item.ClaseGuia === "E" &&
          item.Estado !== "C",
      );
    }
    //si es guia y no esta debe buscar en las guias
    if (itemEncontrado) {
      // Llamar a tu función como si hubieras hecho click
      onClickLista(itemEncontrado);
    } else {
      // console.warn("No se encontró el número en la lista:", numeroXML);
      enqueueSnackbar(
        `!!!Número no se encuentrá en la lista o esta completado!!!`,
        {
          variant: "warning",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        },
      );
    }
  };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     // Parseamos el XML
  //     try {
  //       const parser = new DOMParser();
  //       let xmlDoc = parser.parseFromString(e.target.value, "text/xml");
  //       // Buscar el primer elemento <F>
  //       const fElement = xmlDoc.getElementsByTagName("F")[0];

  //       if (fElement) {
  //         const numeroF = fElement.textContent;
  //         buscarPorNumeroXML(numeroF); // Aquí buscamos y ejecutamos onClickLista
  //         e.target.blur();
  //         setOpen(false);
  //       } else {
  //         // console.error("No se encontró el tag <F> en el XML");
  //         enqueueSnackbar(
  //           `!!!No se encuentra el valor en el documento scaneado!!!`,
  //           {
  //             variant: "warning",
  //             anchorOrigin: {
  //               vertical: "top",
  //               horizontal: "right",
  //             },
  //           }
  //         );
  //       }
  //     } catch (error) {
  //       enqueueSnackbar(`!!!Error al Scanear documento : !!!` + error, {
  //         variant: "warning",
  //         anchorOrigin: {
  //           vertical: "top",
  //           horizontal: "right",
  //         },
  //       });
  //     }
  //   }
  // };

  const handle_LostFocus_NDoc = (value) => {};
  const handle_KeyDown_NDoc = (e) => {};
  const handle_Change_NDoc = (e) => {
    setTextoBusqueda(e);
    filtrarListaPorNumero(e);
  };

  const filtrarListaPorNumero = (valor) => {
    const texto = valor.replace(/\D/g, "");
    setTextoBusqueda(texto);
    if (texto.length < 3) {
      setListaFiltrada(datalistMonitor);
      return;
    }
    const filtrados = datalistMonitor.filter(
      (item) =>
        item.Estado !== "C" &&
        (item.Numero?.toString().includes(texto) ||
          item.NumDocRef?.toString().includes(texto) ||
          item.NumGuia?.toString().includes(texto)),
    );
    setListaFiltrada(filtrados);
    // Auto selección si hay uno solo
    // if (filtrados.length === 1) {
    //   onClickLista(filtrados[0]);
    // }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // Evitar que el Enter se propague y active otros controles (como el IconButton)
      e.preventDefault();
      e.stopPropagation();

      try {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(e.target.value, "text/xml");

        //***** Extrayendo datos del documento */
        const fElement = xmlDoc.getElementsByTagName("F")[0];
        const fTipo = xmlDoc.getElementsByTagName("TD")[0];
        //********************************* */

        if (fElement && fTipo) {
          const numeroF = fElement.textContent;
          const tipoDoc = fTipo.textContent;
          // Cerramos el modal primero (evita que el focus-restore active el botón)
          setOpen(false);

          // Ejecutamos la búsqueda después de un pequeño delay para dejar que el modal
          // se desmonte y evitar efectos de foco/race conditions.
          setTimeout(() => {
            buscarPorNumeroXML(numeroF, tipoDoc);
          }, 80);

          // opcional: no hace falta hacer blur si ya cerramos el modal:
          // e.target.blur();
        } else {
          enqueueSnackbar(
            `!!!No se encuentra el valor en el documento scaneado!!!`,
            {
              variant: "warning",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            },
          );
        }
      } catch (error) {
        enqueueSnackbar(`!!!Error al Scanear documento : !!!` + error, {
          variant: "warning",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    }
  };
  //setdatadetalle
  //*********************************************************** */
  return (
    <div>
      <Container maxWidth="sm">
        <Container maxWidth="sm" sx={{ mt: 1 }}></Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box
              borderRadius="8px"
              sx={{ boxShadow: 1, backgroundColor: "#FFFFFF", height: "auto" }}
            >
              {!bSeleccionada ? (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Despachos
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Select
                      value={BodegaSeleccionada} // we want to work in controlled mode
                      displayEmpty
                      fullWidth
                      onChange={handleChangeComboBox} // we want to work in controlled mode
                    >
                      <MenuItem value="" disabled>
                        Sucursales
                      </MenuItem>
                      {sucursales?.map((option) => {
                        return (
                          <MenuItem key={option.Nombre} value={option.Nombre}>
                            {option.Nombre ?? option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Despachos {NomBodega}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
        {bSeleccionada && bSeleccionDesRes && (
          <Box
            borderRadius="8px"
            sx={{
              boxShadow: 1,
              backgroundColor: "#FFFFFF",
              height: "auto",
              p: 3,
              display: "flex",
              justifyContent: "center", // Centra los elementos horizontalmente
              alignItems: "center", // Centra los elementos verticalmente
            }}
          >
            <Grid container spacing={1} sx={{ p: 3 }}>
              <Grid item xs={12}>
                <Stack spacing={2} direction="column">
                  <Button
                    variant="contained"
                    startIcon={<LocalShippingTwoToneIcon />}
                    onClick={onClickDespacho}
                  >
                    Despacho
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<EventNoteTwoToneIcon />}
                    onClick={onClickReserva}
                  >
                    Reserva
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        )}
        {bMostarListado && (
          <>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius={"8px"}
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    color: "text.secondary",
                    p: 1,
                    maxWidth: "100%",
                    textAlign: "right",
                  }}
                >
                  <TextFieldCustom
                    inputRef={NDocRef}
                    label="Nº Documento"
                    color="success"
                    Alineacion="left"
                    onKeyDown={handle_KeyDown_NDoc}
                    onBlur={handle_LostFocus_NDoc}
                    onChange={handle_Change_NDoc}
                    TamanioFuente={"10px"}
                    inputMode="numeric"
                    value={textoBusqueda}
                    maxLength={12}
                  />
                  <IconButton onClick={handleOpen}>
                    <Avatar sx={{ backgroundColor: "DarkOrange" }}>
                      <QrCodeScannerIcon />
                    </Avatar>
                  </IconButton>
                  <Modal open={open} onClose={handleClose} disableRestoreFocus>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100vh",
                        bgcolor: "rgba(0,0,0,0.6)",
                      }}
                    >
                      <Box
                        sx={{
                          bgcolor: "white",
                          p: 4,
                          borderRadius: 2,
                          textAlign: "center",
                          width: 300,
                          position: "relative", // importante para colocar el botón de cerrar arriba a la derecha
                        }}
                      >
                        {/* Botón de cerrar */}
                        <IconButton
                          onClick={handleClose}
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "gray",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>

                        <QrCodeScannerIcon
                          sx={{ fontSize: 60, color: "DarkOrange" }}
                        />
                        <Typography variant="h6" mt={2}>
                          Escaneando código...
                        </Typography>

                        {/* Input oculto */}
                        <TextField
                          inputRef={inputRef}
                          type="text"
                          inputProps={{
                            inputMode: "none", // evita teclado virtual
                          }}
                          sx={{ opacity: 0, height: 0, position: "absolute" }}
                          onKeyDown={handleKeyDown}
                        />
                      </Box>
                    </Box>
                  </Modal>
                  <IconButton onClick={onClickVolver}>
                    <Avatar sx={{ backgroundColor: "MediumPurple" }}>
                      <ListAltIcon />
                    </Avatar>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <List aria-label="contacts">
                    {/* // {datalistMonitor.map((item, index) => (                     */}
                    {listaFiltrada.map((item, index) => (
                      <ListItem key={item.Numero}>
                        {item.Estado === "C" ? (
                          <>
                            <Box
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                backgroundColor: "#F9EBEA",
                                borderRadius: "12px",
                                // m: 1,
                              }}
                            >
                              <ListItemText
                                sx={{ m: 2 }}
                                primary={
                                  <>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="DarkGrey"
                                    >
                                      {" "}
                                      {item.Referencia}
                                    </Typography>
                                  </>
                                }
                                secondary={
                                  <>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="DarkGrey"
                                    >
                                      Nº:
                                    </Typography>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="DarkGrey"
                                    >
                                      {" "}
                                      {item.Numero}
                                    </Typography>{" "}
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="DarkGrey"
                                    >
                                      Fecha:
                                    </Typography>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="DarkGrey"
                                    >
                                      {" "}
                                      {format(
                                        new Date(item.FechaDoc),
                                        "dd-MM-yyyy",
                                      )}
                                    </Typography>
                                    <br />
                                  </>
                                }
                              />
                            </Box>
                          </>
                        ) : (
                          <ListItemButton
                            sx={{
                              width: "100%",
                              backgroundColor:
                                index % 2 === 0 ? "#F4F6F6 " : "#F2F4F4",
                              borderRadius: "8px",
                            }}
                            onClick={() => onClickLista(item)}
                          >
                            {/* <ListItemText
                              primary={`Nº:${item.Numero} / ${format(
                                new Date(item.FechaDoc),
                                "dd-MM-yyyy"
                              )} / ${item.Referencia}`}
                            /> */}
                            <ListItemText
                              sx={{ m: 0 }}
                              primary={
                                <>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="Blue"
                                  >
                                    {" "}
                                    {item.Referencia}
                                  </Typography>
                                </>
                              }
                              secondary={
                                <>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    Nº:
                                  </Typography>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {" "}
                                    {item.Numero}
                                  </Typography>{" "}
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    Fecha:
                                  </Typography>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {" "}
                                    {format(
                                      new Date(item.FechaDoc),
                                      "dd-MM-yyyy",
                                    )}
                                  </Typography>
                                  <br />
                                </>
                              }
                            />
                          </ListItemButton>
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
        {/* Mostrar datos Sin seleccionar un items */}
        {bScanResDes && !bMostrarDato && (
          <Grid container sx={{ p: 1 }} spacing={1}>
            <Grid item xs={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  fullWidth
                  inputRef={ScanBarraRef}
                  label="Scan Cód.Barra"
                  color="success"
                  Alineacion="left"
                  TamanioFuente={"10px"}
                  onKeyDown={handleKeyDownCodBarra}
                  onBlur={handleScanBarraRefLostFocus}
                  inputMode="numeric"
                  maxLength={16}
                  // sx={{ opacity: 0, height: 0, position: "absolute" }}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  disabled
                  id="full"
                  label={`N° - Ref.${sReferencia}`}
                  value={iNumero}
                  TamanioFuente={"12px"}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "right",
                }}
              >
                <IconButton onClick={onClickListado}>
                  <Avatar sx={{ backgroundColor: "purple" }}>
                    <ReceiptLongIcon />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onClickVolver}>
                  <Avatar sx={{ backgroundColor: "MediumPurple" }}>
                    <ListAltIcon />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onclickListadoFaltantes}>
                  <Avatar sx={{ backgroundColor: "DeepPink" }}>
                    <BallotIcon />
                  </Avatar>
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        )}
        {/* Mostrar datos Ya seleccionado un items */}
        {bScanResDes && bMostrarDato && (
          <Grid container sx={{ p: 1 }} spacing={1}>
            <Grid item xs={4}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  fullWidth
                  inputRef={ScanBarraRef}
                  label="Scan Cód.Barra"
                  color="success"
                  Alineacion="left"
                  TamanioFuente={"10px"}
                  onKeyDown={handleKeyDownCodBarra}
                  onBlur={handleScanBarraRefLostFocus}
                  inputMode="numeric"
                  maxLength={16}
                  // sx={{ opacity: 0, height: 0, position: "absolute" }}
                />
              </Box>
            </Grid>
            <Grid item xs={8} rowSpan={2}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 0,
                  maxWidth: "100%",
                  textAlign: "center",
                  display: "flex",
                  height: "68px",
                  justifyContent: "center",
                }}
              >
                <IconButton onClick={onClickActualizar}>
                  <Avatar
                    sx={{ backgroundColor: "green", width: 30, height: 30 }}
                  >
                    <CheckCircleRoundedIcon fontSize="small" />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onClickListado}>
                  <Avatar
                    sx={{ backgroundColor: "purple", width: 30, height: 30 }}
                  >
                    <ReceiptLongIcon fontSize="small" />
                  </Avatar>
                </IconButton>
                <IconButton onClick={handleOpenDialogConfirmacion_return}>
                  <Avatar
                    sx={{ backgroundColor: "red", width: 30, height: 30 }}
                  >
                    <CancelRoundedIcon fontSize="small" />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onclickListadoFaltantes}>
                  <Avatar
                    sx={{ backgroundColor: "DeepPink", width: 30, height: 30 }}
                  >
                    <BallotIcon fontSize="small" />
                  </Avatar>
                </IconButton>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  disabled
                  id="full"
                  label={`N° - Ref.${sReferencia}`}
                  value={iNumero}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={5}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  disabled
                  id="full"
                  label={`Cantidad`}
                  value={iMostrarCantidad}
                  TamanioFuente={"14px"}
                  ColorFuente={"blue"}
                  labelStyle={{
                    color: "blue",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                  fullWidth
                />
              </Box>
            </Grid>

            <Grid item xs={7}>
              <Box
                borderRadius={"8px"}
                sx={{
                  display: "flex", // Utilizamos flex para colocar los elementos en línea
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  // textAlign: "left",
                }}
              >
                <TextFieldCustom
                  id="full"
                  label={`No Entregado`}
                  value={iMostrarNoEntregado}
                  TamanioFuente={"14px"}
                  labelStyle={{
                    color: "blue",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                  fullWidth
                  inputMode="numeric"
                  maxLength={11}
                  isNumeric={true} // si es numerico
                  decimal={true} // Indica si es decimal
                  decimalCantidad={2} //numero de decima
                  onFocus={handle_GotFocus_NoEntregado}
                  onChange={handle_Change_NoEntregado}
                  onBlur={handle_LostFocus_NoEntregado}
                  onKeyDown={handle_KeyDown_NoEntregado}
                  sx={{ flexGrow: 1 }}
                />
                {/* <IconButton
                  onClick={onClickNoEntregado}
                  sx={{ justifyContent: "flex-end", ml: 1 }} // Alinear contenido a la derecha
                >
                  <Avatar
                    sx={{ backgroundColor: "DarkBlue", width: 24, height: 24 }}
                  >
                    <ShoppingCartCheckoutIcon fontSize="small" />
                  </Avatar>
                </IconButton> */}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  display: "flex", // Utilizamos flex para colocar los elementos en línea
                  //flexDirection: "", // Invertimos la dirección de los elementos
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  // textAlign: "left",
                }}
              >
                <TextFieldCustom
                  id="full"
                  label={`Entregado`}
                  value={iMostrarEntregado}
                  TamanioFuente={"16px"}
                  labelStyle={{
                    color: "green",
                    fontSize: "18px",
                    textAlign: "center",
                  }}
                  inputMode="numeric"
                  maxLength={11}
                  isNumeric={true} // si es numerico
                  decimal={true} // Indica si es decimal
                  decimalCantidad={2} //numero de decima
                  onFocus={handle_GotFocus_Entregado} //focus
                  onChange={handle_Change_Entregado} //change
                  onBlur={handle_LostFocus_Entregado} //al salir foco
                  onKeyDown={handle_KeyDown_Entregado} // al soltar un boton
                  sx={{ flexGrow: 1 }}
                />
                {/* <IconButton
                  onClick={onClickEntregado}
                  sx={{ justifyContent: "flex-end", ml: 1 }} // Alinear contenido a la derecha
                >
                  <Avatar
                    sx={{ backgroundColor: "DarkBlue", width: 24, height: 24 }}
                  >
                    <ShoppingCartCheckoutIcon fontSize="small" />
                  </Avatar>
                </IconButton> */}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  disabled
                  id="full"
                  label={`Preparado`}
                  value={iMostrarPreparado}
                  TamanioFuente={"14px"}
                  labelStyle={{
                    color: "blue",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextFieldCustom
                  disabled
                  id="full"
                  label={`Pendiente`}
                  value={iMostrarPendiente}
                  TamanioFuente={"14px"}
                  labelStyle={{
                    color: "blue",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextField
                  disabled
                  id="full"
                  label={`Código ${sMostrarCodigo}`}
                  value={sMostrarDescripcion}
                  fullWidth
                  multiline
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "right",
                }}
              >
                <IconButton onClick={onClickListado}>
                  <Avatar sx={{ backgroundColor: "purple" }}>
                    <ReceiptLongIcon />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onClickVolver}>
                  <Avatar sx={{ backgroundColor: "MediumPurple" }}>
                    <ListAltIcon />
                  </Avatar>
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        )}
        {bListadoFaltante && (
          <>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius={"8px"}
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    color: "text.secondary",
                    p: 1,
                    maxWidth: "100%",
                    textAlign: "right",
                  }}
                >
                  <IconButton onClick={onClickScann}>
                    <Avatar sx={{ backgroundColor: "GreenYellow" }}>
                      <CropFreeIcon />
                    </Avatar>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <List aria-label="contacts">
                    {datadetalle.map((item, index) => (
                      <>
                        {item.Pendiente > 0 && (
                          <>
                            <ListItem key={item.Codigo}>
                              <ListItemText
                                primary={item.Codigo}
                                secondary={
                                  <>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.primary"
                                    >
                                      {item.Nombre}
                                    </Typography>
                                    <br />
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.secundary"
                                    >
                                      Cantidad : {item.Cantidad}
                                    </Typography>
                                    <br />
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.secundary"
                                    >
                                      Entregado : {item.Entregado}
                                    </Typography>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.secundary"
                                    >
                                      <br />
                                      Preparado : {item.Preparado}
                                    </Typography>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.secundary"
                                    >
                                      <br />
                                      Pendiente : {item.Pendiente}
                                    </Typography>
                                    <br />
                                  </>
                                }
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}
                      </>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </div>
  );
};
export default Despachos;
